// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage, useIntl } from "react-intl";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../../app/actions/generalActions";
import * as uiHelpers from "../ObjectsUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toAbsoluteUrl,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useObjectsUIContext } from "../ObjectsUIContext";
import { useFilterObjectsUIContext } from "../FilterObjectsUIContext";
import { useBuildingUIContext } from "../../../../../../app/modules/BaseInfo/building/BuildingUIContext";
import { StimulSoftViewer } from "../../../../../../app/modules/customComponents/stimulReport/StimulSoftViewer";
import { useHistory } from "react-router-dom";

export const ObjectsTable = ({
  api,
  getFunctionName,
  columns,
  currentState,
  haveGeneralAction = true,
  isFullAccess,
  groupSettingAction = false,
  AuditAction = false,
  filterByShowButton = false,
  parentId,
  prentName,
  hideSelected = false,
  checkActive = false,
  rowFormatter,
  showAuditResultForm = false,
  enablePagination = true,
  haveStimulsoftReport = false,
  mrtUrl,
  jsonFileName,
  detailColumns,
  setParentData,
  setDetailData,
}) => {
  // console.log("currentState : " + currentState)
  // console.log("api : " + api)
  // console.log("actions : " + actions)
  // console.log("sliceActions : " + sliceActions)
  // console.log("callTypes : " + callTypes)
  // Objects UI Context //isFullAccess={isFullAccess}

  const intl = useIntl();
  const history = useHistory()

  const objectsUIContext = useObjectsUIContext();
  const filterUIContext = useFilterObjectsUIContext();

  const { ExportCSVButton } = CSVExport;

  const objectsUIProps = useMemo(() => {
    return {
      ids: objectsUIContext.ids,
      setIds: objectsUIContext.setIds,
      queryParams: filterUIContext.queryParams,
      setQueryParams: filterUIContext.setQueryParams,
      openEditObjectPage: objectsUIContext.openEditObjectPage,
      openFloorsPage: objectsUIContext.openFloorsPage,
      openRoomsPage: objectsUIContext.openRoomsPage,
      openDeleteObjectDialog: objectsUIContext.openDeleteObjectDialog,
      openRefreshObjectDialog: objectsUIContext.openRefreshObjectDialog,
      openAttendenceSettingPage: objectsUIContext.openAttendenceSettingPage,
      openCullinanSettingPage: objectsUIContext.openCullinanSettingPage,
      openDormSettingPage: objectsUIContext.openDormSettingPage,
      openSportSettingPage: objectsUIContext.openSportSettingPage,
      openAuditOptionDialog: objectsUIContext.openAuditOptionDialog,
      changeFilter: objectsUIContext.changeFilter,
      setChangeFilter: objectsUIContext.setChangeFilter,
    };
  }, [objectsUIContext, filterUIContext]);


  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );
  const { totalCount, entities, listLoading, name } = currentState;
  const [showStimul, setShowStimul] = useState(false);

  // useEffect(() => {
  // columns[columns.length-1].formatExtraData = {
  //   openEditObjectPage: objectsUIProps.openEditObjectPage,
  //   openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  // };
  if (haveGeneralAction) {
    if (columns.find(q => q.dataField === "action")) { columns.pop() }

    if (isFullAccess) {
      if (name === "buildings") {
        columns.push({
          dataField: "action",
          text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
          // text: "Actions",
          formatter: columnFormatters.ActionsColumnFormatter,
          formatExtraData: {
            openFloorsPage: objectsUIProps.openFloorsPage,
            openEditObjectPage: objectsUIProps.openEditObjectPage,
            openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
            openRefreshObjectDialog: objectsUIProps.openRefreshObjectDialog,
            isFullAccess: isFullAccess
          },
          classes: "text-right pr-0",
          headerClasses: "text-right pr-3",
          style: {
            minWidth: "100px",
          },
        })
      }
      else if (name === "floors") {
        columns.push({
          dataField: "action",
          text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
          // text: "Actions",
          formatter: columnFormatters.ActionsColumnFormatter,
          formatExtraData: {
            openRoomsPage: objectsUIProps.openRoomsPage,
            openEditObjectPage: objectsUIProps.openEditObjectPage,
            openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
            openRefreshObjectDialog: objectsUIProps.openRefreshObjectDialog,
            isFullAccess: isFullAccess
          },
          classes: "text-right pr-0",
          headerClasses: "text-right pr-3",
          style: {
            minWidth: "100px",
          },
        })
      }
      else {
        columns.push({
          dataField: "action",
          text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
          // text: "Actions",
          formatter: columnFormatters.ActionsColumnFormatter,
          formatExtraData: {
            openEditObjectPage: objectsUIProps.openEditObjectPage,
            openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
            openRefreshObjectDialog: objectsUIProps.openRefreshObjectDialog,
            isFullAccess: isFullAccess
          },
          classes: "text-right pr-0",
          headerClasses: "text-right pr-3",
          style: {
            minWidth: "100px",
          },
        })
      }

    }
    else {

      if (name === "buildings") {
        columns.push({
          dataField: "action",
          text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
          // text: "Actions",
          formatter: columnFormatters.ActionsColumnFormatter,
          formatExtraData: {
            openFloorsPage: objectsUIProps.openFloorsPage,
            openEditObjectPage: objectsUIProps.openEditObjectPage,
            isFullAccess: isFullAccess
          },
          classes: "text-right pr-0",
          headerClasses: "text-right pr-3",
          style: {
            minWidth: "100px",
          },
        })
      }
      else if (name === "floors") {
        columns.push({
          dataField: "action",
          text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
          // text: "Actions",
          formatter: columnFormatters.ActionsColumnFormatter,
          formatExtraData: {
            openRoomsPage: objectsUIProps.openRoomsPage,
            openEditObjectPage: objectsUIProps.openEditObjectPage,
            isFullAccess: isFullAccess
          },
          classes: "text-right pr-0",
          headerClasses: "text-right pr-3",
          style: {
            minWidth: "100px",
          },
        })
      }
      else {
        columns.push({
          dataField: "action",
          text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
          // text: "Actions",
          formatter: columnFormatters.ViewColumnFormatter,
          formatExtraData: {
            openEditObjectPage: objectsUIProps.openEditObjectPage,
            isFullAccess: isFullAccess
          },
          classes: "text-right pr-0",
          headerClasses: "text-right pr-3",
          style: {
            minWidth: "100px",
          },
        })
      }



    }
  }
  else if (AuditAction) {
    if (columns.find(q => q.dataField === "action")) { columns.pop() }

    columns.push({
      dataField: "action",
      text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
      // text: "Actions",
      formatter: columnFormatters.ViewColumnFormatter,
      formatExtraData: {
        openEditObjectPage: objectsUIProps.openEditObjectPage,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    })
  }
  else if (groupSettingAction) {
    // if (columns.find(q => q.dataField === "action")) { columns.pop() }

    columns.push({
      dataField: "action",
      text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
      // text: "Actions",
      formatter: columnFormatters.GroupSettingActionsColumnFormatter,
      formatExtraData: {
        openAttendenceSettingPage: objectsUIProps.openAttendenceSettingPage, accessAttendence: true,
        openCullinanSettingPage: objectsUIProps.openCullinanSettingPage, accessCullinan: true,
        openDormSettingPage: objectsUIProps.openDormSettingPage, accessDorm: true,
        openSportSettingPage: objectsUIProps.openSportSettingPage, accessSport: true,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    })
  }
  else if (showAuditResultForm) {
    if (columns.find(q => q.dataField === "auditFormTypeTitle")) { columns.pop() }
    columns.push({
      dataField: "auditFormTypeTitle",
      text: "پرسشنامه",
      formatter: columnFormatters.AuditFormsColumnFormatter,
      formatExtraData: {
        openEditObjectPage: objectsUIProps.openEditObjectPage
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    })
  }
  else if (AuditAction) {
    // if (columns.find(q => q.dataField === "action")) { columns.pop() }

    columns.push({
      dataField: "action",
      text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
      // text: "Actions",
      formatter: columnFormatters.AuditActionsColumnFormatter,
      formatExtraData: {
        openAuditOptionDialog: objectsUIProps.openAuditOptionDialog
      },
      // formatter: columnFormatters.AuditActionsColumnFormatter,
      // formatExtraData: {
      //   openEditObjectPage: objectsUIProps.openEditObjectPage
      // },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    })
  }

  // }, []);

  // // Getting curret state of objects list from store (Redux)
  // const { currentState } = useSelector(
  //   (state) => ({ currentState: state.objects }),
  //   shallowEqual
  // );


  // useEffect(() => {
  //   objectsUIProps.setIds([]);
  //   dispatch(actions.fetchObjects("forceEmpty", name, objectsUIProps.queryParams))
  // }, []);

  // Objects Redux state
  const dispatch = useDispatch();
  useEffect(() => {

    if (filterByShowButton) {
      objectsUIProps.setIds([]);
      dispatch(actions.fetchObjects("forceEmpty", name, objectsUIProps.queryParams))
    }
  }, []);

  useEffect(() => {

    // if (haveStimulsoftReport) {
    //   setShowStimul(false)
    // }

    if (filterByShowButton) {
      if (objectsUIProps.changeFilter) {
        // clear selections list
        objectsUIProps.setIds([]);
        dispatch(actions.fetchObjects("forceEmpty", name, objectsUIProps.queryParams))
        // server call by queryParams
        dispatch(actions.fetchObjects(api, name, objectsUIProps.queryParams, getFunctionName));
        objectsUIProps.setChangeFilter(false);
      }
    }
    else {
      objectsUIProps.setIds([]);
      dispatch(actions.fetchObjects("forceEmpty", name, objectsUIProps.queryParams))
      if (parentId) {
        const query = { ...objectsUIProps.queryParams }
        query.whereClause = ""
        query.whereClauseParameters = []
        query.whereClause = `${prentName}=@0`;
        query.whereClauseParameters.push(parentId);
        // }
        dispatch(actions.fetchObjects(api, name, query, getFunctionName));
      }
      else {
        dispatch(actions.fetchObjects("forceEmpty", name, objectsUIProps.queryParams))
        objectsUIProps.setIds([]);
        dispatch(actions.fetchObjects(api, name, objectsUIProps.queryParams, getFunctionName));
      }
    }

  }, [objectsUIProps.queryParams, dispatch, objectsUIProps.changeFilter, parentId]);
  // Table columns

  useEffect(() => {
    if (haveStimulsoftReport && currentState.entities) {
      //history.push("/testReport");
      sessionStorage.setItem("stimulReport", JSON.stringify(currentState.entities));
      sessionStorage.setItem("mrtUrl", JSON.stringify(mrtUrl));
      sessionStorage.setItem("jsonFileName", JSON.stringify(jsonFileName));
      //setShowStimul(true)
      window.open("/testReport", "_blank");
      // window.open('http://example.com/child-path', 'Data', 'height=250,width=250');
    }
  }, [currentState.entities]);


  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {intl.formatMessage({ id: "SHOW" })} {from} {intl.formatMessage({ id: "TO" })} {to} {intl.formatMessage({ id: "OF" })} {size} {intl.formatMessage({ id: "RESULT" })}
    </span>
  );

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: objectsUIProps.queryParams.pageSize,
    page: objectsUIProps.queryParams.pageNumber,
    paginationTotalRenderer: customTotal,
  };


  const getNowtime = () => {
    let nowDateTime = new Date();
    let nowTime = nowDateTime.toLocaleTimeString("en-US", {
      hour12: false,
      hour: "numeric",
      minute: "numeric",
    });

    let nowDate = nowDateTime.toLocaleDateString("en-US");
    return "D" + nowDate + "T" + nowTime;
  };

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-success" onClick={handleClick}>
          خروجی CSV
        </button>
      </div>
    );
  };

  const expandRow = {
    renderer: row => (
      <div>
        <BootstrapTable
          wrapperClasses="table-responsive"
          rowStyle={{ fontSize: 12 }}
          // headerClasses="font-sm "
          rowClasses={rowFormatter}
          classes="table table-head-custom table-vertical-center overflow-hidden align-middle striped"
          bootstrap4
          bordered={true}
          striped={true}
          remote
          keyField="id"
          data={entities === null ? [] : setDetailData(row.id, entities)}
          // columns={reportUIProps.queryParams.filter.reportType === 1 ? detailColumns : detailColumns2}
          columns={detailColumns}
        // defaultSorted={uiHelpers.defaultSorted}
        // onTableChange={getHandlerTableChange(
        //   reportUIProps.setQueryParams
        // )}
        >
        </BootstrapTable>
      </div>

    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      // if (isAnyExpands) {
      //   return <b>-</b>;
      // }
      // return <b>+</b>;
    },
    // expandColumnRenderer: ({ expanded }) => {
    //   if (expanded) {
    //     return (
    //       // <b>-</b>
    //       <span className="svg-icon svg-icon-md svg-icon-dark">
    //         <SVG
    //           src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-double-up.svg")}
    //         />
    //       </span>
    //     );
    //   }
    //   return (
    //     <span className="svg-icon svg-icon-md svg-icon-dark">
    //       <SVG
    //         src={toAbsoluteUrl("/media/svg/icons/Navigation/Angle-double-down.svg")}
    //       />
    //     </span>
    //     // <b>+</b>
    //   );
    // }
  };

  // const exportPdf = () => {

  //   html2canvas(document.querySelector("#capture")).then(canvas => {
  //     document.body.appendChild(canvas);  // if you want see your screenshot in body.
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();
  //     pdf.addImage(imgData, 'PNG', 0, 0);
  //     pdf.save("download.pdf");
  //   });

  // }

  return (
    <>
      {enablePagination && !detailColumns &&
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <Pagination
                isLoading={listLoading}
                paginationProps={paginationProps}
              >
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  rowClasses={rowFormatter}
                  bootstrap4
                  bordered={false}

                  remote
                  keyField="id"
                  data={entities === null ? [] : entities}
                  columns={columns}
                  defaultSorted={uiHelpers.defaultSorted}
                  onTableChange={getHandlerTableChange(
                    objectsUIProps.setQueryParams
                  )}
                  selectRow={getSelectRow({
                    entities,
                    ids: objectsUIProps.ids,
                    setIds: objectsUIProps.setIds,
                    hideSelected: hideSelected,
                    nonSelectableIds: checkActive ? entities && entities.filter(q => q.status !== "Enable" && q.status !== "EnableMustConfirm").map(q => q.id) : []
                  })}
                  {...paginationTableProps}
                >
                  <PleaseWaitMessage entities={entities} />
                  <NoRecordsFoundMessage entities={entities} />
                </BootstrapTable>
              </Pagination>
            );
          }}
        </PaginationProvider>
      }

      {!enablePagination && !detailColumns &&
        <BootstrapTable
          wrapperClasses="table-responsive"
          classes="table table-head-custom table-vertical-center overflow-hidden"
          rowClasses={rowFormatter}
          bootstrap4
          bordered={false}
          striped={true}
          remote
          keyField="id"
          data={entities === null ? [] : entities}
          // expandRow={detailColumns ? expandRow : null}
          columns={columns}
          defaultSorted={uiHelpers.defaultSorted}
          onTableChange={getHandlerTableChange(
            objectsUIProps.setQueryParams
          )}
        >
          <PleaseWaitMessage entities={entities} />
          <NoRecordsFoundMessage entities={entities} />
        </BootstrapTable>
      }

      {!enablePagination && detailColumns &&
        <BootstrapTable
          wrapperClasses="table-responsive"
          classes="table table-head-custom table-vertical-center overflow-hidden"
          rowClasses={rowFormatter}
          bootstrap4
          bordered={false}
          striped={false}
          remote
          keyField="id"
          data={entities === null ? [] : entities}
          expandRow={expandRow}
          columns={columns}
          defaultSorted={uiHelpers.defaultSorted}
          onTableChange={getHandlerTableChange(
            objectsUIProps.setQueryParams
          )}

        >
          <PleaseWaitMessage entities={entities} />
          <NoRecordsFoundMessage entities={entities} />
        </BootstrapTable>
      }

      {haveStimulsoftReport && showStimul &&
        <StimulSoftViewer
          mrtUrl='/reports/GetPlacesReport.mrt'
          currentState={currentState}
          api="api/group"
        />
      }
    </>
  );
}
